import React from "react";
import "./about.scss";
import logo from "../../../Media/Ruko BSD/Capital Cove/Capital Cove (1).webp";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6282172727291&text=Halo%20Swandy,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Komersial%20BSD%20Gading%20Serpong%20(About)%20https://komersialbsdgadingserpong.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const about = ({poin, judul, Deskrisi}) => {
  return (
    <div id="about" className="container-about">
      <div className="container-deskripsi">
        <div className="judulsumbog">
          <h1>{judul}</h1>
        </div>
        <div className="deskripsi-about">{Deskrisi}</div>
      </div>
      <div className="rowcontainer">
        <div className="featurelist">
          {poin.map((image, index) => (
            <div className="feature" index={index}>
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp; {image}</span>
            </div>
          ))}

          <div className="button">
            <div className="container-wa">
              <button
                className="buttonpenawaran"
                onClick={handleConsultationClick}>
                Learn More
              </button>
            </div>
          </div>
        </div>
        <div className="logo-about">
          <img
            className="gambar-logo"
            src={logo}
            alt="logo-summarecon-serpong"
          />
        </div>
      </div>
    </div>
  );
};

export default about;
